import { Button } from '@mui/material';
import { EmployeeAvailableColumns } from '../services/react-query/employees';
import { Employee } from '../types/Employee';
import { AvailableColumn } from '../uikit/itable/ITable';
import PreferencesPopover from '../components/common/popover/PreferencesPopover';
import { tagToDisplay } from '../types/Tag';
import React from 'react';
import CustomAxios from './customAxios';
import { IFilter } from '../components/common/filters/interfaces';
import { Preference } from '../types/Preference';
import { mapOptionsFromPreferences } from './filterUtils';
import { archiveFilter, tagFilter } from '../components/common/filters/consts';
import _ from 'lodash';
import EmailLink from '../components/common/EmailLink/EmailLink';
import PhoneLink from '../components/common/PhoneLink/PhoneLink';
import { UserConfigurableModule } from '../types/User';
import DrawerLink from '../components/common/drawers/ModuleDrawer/DrawerLink';

export const EmployeeColumns: AvailableColumn<Employee, EmployeeAvailableColumns>[] = [
  {
    key: 'display_name',
    label: 'Name',
    render: (employee) => (
      <DrawerLink module={UserConfigurableModule.EMPLOYEES} uuid={employee.uuid}>
        {employee.display_name}
      </DrawerLink>
    ),
  },

  {
    key: 'roles',
    label: 'Roles',
    render: (employee) => <PreferencesPopover values={employee.roles_values} />,
    sortable: false,
  },
  {
    key: 'title_value',
    label: 'Title',
    render: (employee) => employee.title_value,
  },
  {
    key: 'email',
    label: 'Email',
    render: (employee) => <EmailLink email={employee.email} />,
  },
  {
    key: 'phone',
    label: 'Phone',
    render: (employee) => <PhoneLink phone={employee.phone || '-'} extension={employee.extension} />,
  },
  {
    key: 'invite',
    label: 'Invite',
    sortable: false,
    render: (employee) => (
      <Button sx={{ height: '28px' }} onClick={(event) => handleInviteEmployee(event, employee.uuid)} disabled={employee.invited}>
        Invite to Schedulink
      </Button>
    ),
  },
  {
    key: 'tags',
    label: 'Tags',
    sortable: false,
    render: (employee) => <PreferencesPopover values={_.map(employee.tags, tagToDisplay)} />,
  },
];

export const handleInviteEmployee = async (event: React.MouseEvent, uuid: string) => {
  event.stopPropagation();
  try {
    await CustomAxios.post(`/employees/invite/${uuid}`);
  } catch (e) {
    alert(JSON.stringify(e));
  }
};

export const EmployeeFilters = (preferences?: Preference[]): IFilter[] => [
  {
    label: 'Employee Role',
    key: 'employee_role',
    type: 'dropdown',
    options: mapOptionsFromPreferences(preferences || [], 'employee_role'),
  },
  {
    label: 'Employee Title',
    key: 'employee_title',
    type: 'dropdown',
    options: mapOptionsFromPreferences(preferences || [], 'employee_title'),
  },
  tagFilter,
  archiveFilter,
];

export const EmployeesScheduleFilters = (preferences: Preference[]): IFilter[] => [
  {
    label: 'Employees',
    key: 'uuid',
    type: 'employee',
  },
  {
    label: 'Roles',
    key: 'employee_role',
    type: 'dropdown',
    options: mapOptionsFromPreferences(preferences || [], 'employee_role'),
  },
  {
    label: 'Titles',
    key: 'employee_title',
    type: 'dropdown',
    options: mapOptionsFromPreferences(preferences || [], 'employee_title'),
  },
  {
    ...tagFilter,
    label: 'Employee Tags', // to make clear we're filtering by employee, not event
  }
];
